import { render, staticRenderFns } from "./RegisterItem.vue?vue&type=template&id=55bb3ada&"
import script from "./RegisterItem.vue?vue&type=script&lang=js&"
export * from "./RegisterItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports